import { AUTH_BASE_URL } from "../../../constants";
import { AuthConfig } from "../../../context/config/authConfig";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IBankDetailsResponse, IContractDetailsBody } from "./model";

import { BANK_PATH } from "./constants";

const appProvide = async () => AuthConfig.getAppToken();

export const getBankDetails = (): Promise<IBankDetailsResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/${BANK_PATH}`,
    "GET",
    appProvide
  );
  return fetchRequest(descriptor);
};

export const updateBankDetails = (
  body: IContractDetailsBody
): Promise<IBankDetailsResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}${BANK_PATH}`,
    "POST",
    appProvide
  );
  return fetchRequest(descriptor, body);
};
